<template>
    <div>
        <!-- <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">大用户划账优惠</a></li>
            </ul>
        </div> -->
    
    <div id="usual1" class="usual"> 
 
  	<div class="formbody">
    
    <div class="formtitle"><span>大用户划账优惠</span></div>
    
    <ul class="forminfo">

    </ul>
    <div class="jian">&nbsp;</div>
    
    <table class="tablelist">
    	<thead>
    	<tr>
        
        <th>功能账户</th>
        <th>单次满100送</th>
        <th>单次满200送</th>
        <th>单次满500送</th>
        <th>单次满1000送</th>
        <th>单次满2000送</th>
        <th>单次满5000送</th>
        <th>单次满10000送</th>
        <th>单次满20000送</th>
        </tr>
        </thead>
        <tbody>
        
        <tr>
        <td>短信功能账户</td>
        <td>2% <b class="ea2020">VIP1+5%</b></td>
        <td>3% <b class="ea2020">VIP1+5%</b></td>
        <td>5% <b class="ea2020">VIP1+5%</b></td>
        <td>6% <b class="ea2020">VIP1+5%</b></td>
        <td>8% <b class="ea2020">VIP1+5%</b></td>
        <td>10% <b class="ea2020">VIP1+5%</b></td>
        <td>12% <b class="ea2020">VIP1+5%</b></td>
        <td>15% <b class="ea2020">VIP1+5%</b></td>
        </tr>
        
        <tr>
        <td>彩信功能账户</td>
        <td>2%</td>
        <td>3%</td>
        <td>5%</td>
        <td>6%</td>
        <td>8%</td>
        <td>10%</td>
        <td>10%</td>
        <td>10%</td>
        </tr>
        
        <!-- <tr>
        <td>发传真功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%</td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        <!-- <tr>
        <td>收传真功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%</td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        <!-- <tr>
        <td>400总机功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%</td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        <!-- <tr>
        <td>800功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%</td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        
        <!-- <tr>
        <td>会议功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%</td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        <tr>
        <td>点击通话功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>8% </td>
        <td>8%</td>
        <td>8%</td>
        <td>8%</td>
        <td>8%</td>
        </tr>
        
        <!-- <tr>
        <td>语音短信功能账户</td>
        <td>3%</td>
        <td>5%</td>
        <td>8%</td>
        <td>10%  </td>
        <td>12%</td>
        <td>15%</td>
        <td>15%</td>
        <td>15%</td>
        </tr> -->
        
        <tr>
        <td>邮件功能账户</td>
        <td>5%</td>
        <td>8%+<b class="ea2020">42%</b></td>
        <td>15%+<b class="ea2020">35%</b></td>
        <td>20%+<b class="ea2020">30%</b></td>
        <td>25%+<b class="ea2020">25%</b></td>
        <td>30% <b class="ea2020">20%</b></td>
        <td>30% <b class="ea2020">20%</b></td>
        <td>30% <b class="ea2020">20%</b></td>
        </tr>
        
        </tbody>
    </table>
    
    <div class="jian">&nbsp;</div>
    
   
    <ul class="infolist">
    <li><span class="ea2020 f16">说明：</span></li>
    <li><span>1、在线充值默认充到总账户; 总账户的钱可以供各功能使用,功能账户的钱仅供对应功能使用</span></li> 
    <li><span>2、大用户优惠幅度根据成本及促销计划,不定期调整</span></li>
    <li>
        <span>3、优惠仅在从总账户向功能账户中划账时自动赠送（划账前请通过支付宝或网银向总账户预充钱，保留足够余额）</span>
        <!-- <a class="ibtn" href="/account">马上划账</a> -->
        <el-tooltip class="item" effect="dark" content="注册二办用户登录后方可划账" placement="top-start">
            <el-button type="primary" style="letter-spacing: 1px;" size="mini" @click="reg()">马上划账</el-button>
        </el-tooltip>
    </li>  
    <li><span>4、划账后的功能账户金额不能反划回总账户，也不支持退款账户。</span></li> 
    <li><span>5、系统扣款流程：系统优先从功能账户中扣费，如功能账户不足，再向总账户扣费；</span></li>
    <li><span>6、内容保证金（试行）：</span></li>
    <li><span>为保证系统整体安全，避免小部分用户违规恶意使用，发送非法及黄色信息等，造成系统被查封而影响全体用户；</span></li>
    <li><span>部分功能（如106短信通道、彩信、传真）需交纳一定金额的内容保证金并经客服审核后方可继续使用。</span></li>
    <li><span>该保证金在用户停止使用对应功能30天后，可退还到总账户；</span></li>
    <li><span>当用户违法使用或发送违规、黄色内容（具体参用户协</span></li>
    <li><span>议）时，云验证有权冻结查封该用户所有余额及保证金，并追索法律责任及其他经济赔偿款账户。</span></li>
    </ul>
    </div> 
  	
	</div> 
    </div>
</template>

<script>
export default {
    methods: {
        reg() {
            window.open('/reg');
        }
    }
}

</script>



// WEBPACK FOOTER //
// src/components/shouye/youhuiindex.vue